import React from "react";
import { ErrorMessage } from "formik";
import { isEmpty } from "ramda";
import "./Marketing.scss";

const Name = ({
  label,
  placeholder,
  index,
  field: { name, validateField, value },
  form: { setFieldValue, setFieldTouched, errors, touched }
}) => {
  return (
    <div className="field">
      <label className="label">{label}</label>
      <input
        validate={validateField}
        className="input"
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={e => {
          setFieldTouched(name, true, true);
          setFieldValue(name, e.target.value);
        }}
        onBlur={e => {
          setFieldTouched(name, true, true);
          setFieldValue(name, e.target.value);
        }}
        index={index}
      />
      {touched[name] && !isEmpty(errors.name) ? (
        <span className="validation-message">{errors.name}</span>
      ) : (
        <ErrorMessage
          name={`participants.${index}.participantName`}
          className="validation-message"
          component="span"
        />
      )}
    </div>
  );
};

export default Name;
